module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Chapter01#ch1"
    }
  }, [_c('span', {
    staticClass: "ftoc"
  }, [_vm._v("Chapter 1")]), _vm._v(" Thank God for The Navy! (April 1940)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ftoc"
  }, [_vm._v("Chapter 2")]), _vm._v(" Biplanes Against Battleships – Operation ‘Judgement’ (11–12 November 1940)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ftoc"
  }, [_vm._v("Chapter 3")]), _vm._v(" Operation ‘Excess’ (January 1941)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ftoc"
  }, [_vm._v("Chapter 4")]), _vm._v(" Hunting the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bismarck")]), _vm._v(" (May 1941)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ftoc"
  }, [_vm._v("Chapter 5")]), _vm._v(" Unternehmen ‘Donnerkeil-Zerberus’ (February 1942)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ftoc"
  }, [_vm._v("Chapter 6")]), _vm._v(" Sink The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tirpitz")]), _vm._v("! (9 March 1942 – 29 August 1944)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ftoc"
  }, [_vm._v("Chapter 7")]), _vm._v(" Hunting the Hunters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ftoc"
  }, [_vm._v("Chapter 8")]), _vm._v(" Pearl Harbor and the US Pacific Fleet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ftoc"
  }, [_vm._v("Chapter 9")]), _vm._v(" Attack On Davao (19 December 1941)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ftoc"
  }, [_vm._v("Chapter 10")]), _vm._v(" Battle of the Coral Sea (4–8 May 1942)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ftoc"
  }, [_vm._v("Chapter 11")]), _vm._v(" The Battle of Midway (4–7 June 1942)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ftoc"
  }, [_vm._v("Chapter 12")]), _vm._v(" The Battle for the Solomons (August–November 1942)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ftoc"
  }, [_vm._v("Chapter 13")]), _vm._v(" The Battle of the Philippine Sea (June 19–20, 1944)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ftoc"
  }, [_vm._v("Chapter 14")]), _vm._v(" The British Pacific Fleet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ftoc"
  }, [_vm._v("Chapter 15")]), _vm._v(" Towards the Final Downfall")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147245f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 63
// module chunks = 0